__turbopack_context__.v({
  "body": "hzEHQq_body",
  "bow": "hzEHQq_bow",
  "burst": "hzEHQq_burst",
  "fly": "hzEHQq_fly",
  "giftBox": "hzEHQq_giftBox",
  "glow": "hzEHQq_glow",
  "lid": "hzEHQq_lid",
  "lidOff": "hzEHQq_lidOff",
  "mark": "hzEHQq_mark",
  "pop": "hzEHQq_pop",
  "reveal": "hzEHQq_reveal",
  "ribbon": "hzEHQq_ribbon",
  "shake": "hzEHQq_shake",
  "stageView": "hzEHQq_stageView",
});
